export default {
  '主頁': 'Homepage',
  '一般查證': 'ID Checking',
  '大量查證': 'Bulk ID Checking',
  '上傳檔案': 'Upload file',
  '下載查證結果': 'Download verification result',
  '下載格式': 'Download Excel Format',
  '大量查證失敗!請確認上傳格式是否正確，或聯絡開通中心 0800-222-179 ，謝謝': 'Bulk checking failed! Check the upload format or contact 02-8227-3308 ext. 20 or 21. Thank you.',
  '補卡查證': 'Replacement Card',
  '升級查證': 'Upgrade',
  '門號查詢': 'Check Sim Status',
  '查證紀錄': 'Checking Record',
  '問題紀錄': 'Problem Record',
  '登出': 'Log out',
  '快速功能': 'Function',
  '快速搜尋': 'Search',
  '近期記錄': 'Recent Record',
  '日期': 'Date',
  '證號': 'Passport/ID No.',
  '結果': 'Verification Result',
  '備註': 'Remark',
  '當查證結果等待超過5分鐘時，請聯絡開通中心 02-8227-3308分機20及21，謝謝': "No verification result in 5 mins, call  02-8227-3308 ext. 20 or 21.",
  '已辦過': 'Already Applied',
  '已辦門號': 'Already Applied',
  '欠費': 'Unsettled bill',
  '風險': 'Block Listed',
  '有人查過': 'Someone Checked',
  '護照號碼': 'Passport',
  '目前身份': 'Store/Agent Code *',
  '門號': 'Sim Number',
  '身分證字號': 'Taiwan ID',
  '身分證驗證': 'Verify Taiwan ID',
  '請選擇證件類別': 'Select Type of Documents',
  '請輸入證號': 'Enter Passport No. / ID no.',
  '居留證查詢': 'Residence Card',
  '請輸入生日': 'Enter Birthdate',
  '生日 為必填': 'Birthdate is required',
  '國籍 為必填': 'Nationality is required',
  '生日': 'Birthdate',
  '國籍': 'Nationality',
  '泰國': 'Thailand',
  '印尼': 'Indonesia',
  '越南': 'Vietnam',
  '菲律賓': 'Philippine',
  '印度': 'India',
  '其他': 'Other',
  '中國': 'China',
  '確定': 'Confirm',
  '確定送出': 'Confirm',
  '查證系統': 'Sim Application System',
  '請先登入系統': 'Pls. Log In',
  '手機號碼': 'Mobile Number',
  '取得簡訊驗證碼': 'Get SMS Code',
  '認證碼': 'SMS Code',
  '重新發送驗證碼': 'Resend Code',
  '登入系統': 'Log In',
  '驗證碼錯誤': 'Verification Code Error',
  '系統目前無法登入，請聯絡開通中心 02-8227-3308分機20及21。': "Unable to log in, call 02-8227-3308 ext. 20 or 21.",
  '此電話號碼不存在': 'Invalid Phone Number',
  '無法取的認證碼，請聯絡開通中心 02-8227-3308分機20及21。': "No SMS code, call 02-8227-3308 ext. 20 or 21.",
  '問題件': 'Problem Items',
  '辦門號': 'Sim Application',
  '系統編號': 'System Code',
  '門號類型': 'Document Type',
  '辦門號記錄': 'Activation Record',
  '狀態': 'Status',
  '一般門號': 'General Application',
  '升級': 'Upgrade',
  '換補卡': 'Replacement Card',
  '卡號': 'Serial No.',
  '此卡不在庫存內，請聯絡相關人員。': "Sim is not under your name, pls. call personnel",
  '聯絡電話': 'Contact #',
  '預計開通日': 'Activation Date',
  '仲介名': 'Agency',
  '認證電話': 'Log-in mobile no.',
  '看申請書': 'Check Application Form',
  '中華申請書': 'Chunghwa Application & Terms',
  '請用正楷簽名': 'Printed Name',
  '確認簽名': 'Confirm Name',
  '請閱讀申請書並簽名': 'Please read application & Sign',
  '請將 QRCODE 對準掃瞄框': 'Scan QR CODE',
  '掃描錯誤，內容如下:': "Scan error, cause;",
  '您必須打開鏡頭權限': 'Allow Camera Access',
  '找不到相機': 'Camera not found',
  '相機已經被其他程式佔用': 'Camera is being used by another app',
  '系統無法支援此瀏覽器': "The system don't support this browser",
  '重新掃描': 'Scan Again',
  '清除': 'Delete',
  '取消': 'Cancel',
  '我已閱讀{term}並同意加入九亨會員': 'I have read & agreed {term}',
  '閱讀條款': 'Best We Serve membership terms',
  '請檢查所有欄位是否填寫正確': 'Please make sure all fields are filled in correctly',
  '送件': 'Send File',
  '暫存': 'Saved',
  '關閉': 'Close',
  '刪除': 'Delete',
  '上傳中': 'Sending',
  '讀取中': 'Uploading….',
  '送件完成': 'File Sent Successful',
  '暫存成功': 'Successfully saved',
  '抱歉！找不到此暫存件！': "Sorry we couldn't find the file",
  '確定刪除照片嗎？': 'Delete photo?',
  '確定要刪除此筆？所有的資料都會消失，此動作不可復原？': "Delete this file? All data will be deleted & can't be recovered.",
  '刪除成功': 'Successfully deleted',
  '抱歉！無法暫存，請稍後再試！': 'Unable to save, try again later!',
  '全部': 'All',
  '抱歉！刪除失敗，請稍後再試！': "Sorry, failed to delete！Try again.",
  '未進件': 'File has not been sent',
  '已送件': 'File Sent',
  '預計開通': 'Scheduled activation',
  '已開通': 'Activated',
  '已退卡': 'Returned Sim',
  '已停話': '已停話',
  '照片張數 不得小於{0}': 'Must not be less than {0} photos',
  '門號 為必填': 'Mobile # is required',
  '卡號 為必填': 'Serial # is required',
  '門號不完整': 'Number incomplete',
  '抱歉! 無法暫存，請稍後再試!': 'Sorry , unable to save! Try again.',
  '照片數不能超過 7 張': 'Should not exceed 7 photos',
  '回辦門號紀錄': 'Back to Sim Record',
  '繼續辦門號': 'Apply Sim',
  '回主畫面': 'Back to Home',
  '查證': 'Checking',
  '我己閱讀並了解': 'I have read and understand',
  '如特定開通日期，才需點選': 'For specific activation date, CLICK here!',

  // 大量查證
  '班機': 'Flight Number',
  '班機狀態': 'Flight Status',
  '未知': 'No, flight details for today',
  '準時': 'On time',
  '取消': 'Cancel',
  '延誤': 'Delayed arrival',
  '時間變更': 'Time Change',
  '抵達': 'Arrived',
  '表定抵達時間': 'Scheduled Arrival Time',
  '班機為必填': 'Flight Number is required',
  '落地日期': 'Arrival Date',
  '落地日期及時間 為必填': 'Required',
  '拍正反面：居留證、身份證、學生證、駕照': "Take front and back photos of: Alien Residence Certificate (ARC) or passport, health insurance ID, or Visa, which must have an entry stamp or a Taiwan driver's license and Portrait.",
  '護照、簽證(VISA)、勞動契約及全身照': 'Passport, Visa, and Employment contract ( first page) and Portrait.',
  '看申請書並正楷簽名': 'Read & sign the application',
  '重簽名': 'Sign again',
  '上傳照片': 'Upload Photo',
  '增加照片': 'Add Photo',
  '3張以上,最多7張': 'You can add 3 photos, but not more than 7.',
  '大量辦門號': 'Bulk Application',
  '選取照片': 'Select Photo',
  '點擊上傳或是拖曳照片到畫面中': 'Click to upload or drag the photo to the screen',
  '目前總共選取了{0}張照片': 'Total of {0} photos are selected',
  '重新選擇': 'Select Again',
  '上傳照片': 'Upload Photo',
  '為了上傳更有效率，建議請將圖檔尺寸在 1200x1200 內。': 'To upload efficiently, the recommended  file size is within 1200x1200.',
  '檔名': 'File name',
  '檔案大小': 'File size',
  '下一步': 'Next',
  '上傳失敗！請確認一下網路狀態，或是稍後再試。\n若持續有問題，請聯絡系統管理員。(請聯絡開通中心02-8227-3308分機20及21，謝謝)': 'Upload failed! Check internet connection or try again later. \nIf problem still exists. Please contact  02-8227-3308 ext. 20 or 21.',
  '大量辦門號成功!': 'Bulk application successful',
  '辦門號紀錄上傳中，請勿關閉視窗。': 'Uploading application record, do not close the window.',
  'SIM卡庫存': 'SIM Inventory',
  '庫存': 'Stock',
  '類型': 'Type',
  '動作': 'Select',
  '照片數': 'Number of Photos',
  '上傳狀態': 'Upload Status',
  '上一步': 'Back',
  '目前比對出{0}筆可送件辦門號, 請確認': 'Currently {0} file/s for sim application, please confirm;',
  '暫存門號需有簽名才能比對': 'Each sim application must have printed name with the applicants.',
  '單一門號照片數量,3張以上最多的7張': 'The number of photos of each sim card number must be at least 3 photo & not more than 7.',
  '照片檔要符合檔名規則09XXXXXXXX': 'Photo must be rename with format 09XXXXXXXX.',
  'API呼叫失敗': 'API call failed',

  // 問題件說明
  '問題件類型': 'Problem Item Type',
  '問題件說明': 'Problem Item Details',
  '證件': 'Document',
  '欠費-本期.呆帳.拆機': 'Unsettled bill- due date, uncollectable debt, delinquent',
  '簽名': 'Name',
  '未開通卡片遺失': 'Lost Inactive Simcard',
  '台灣人': 'Taiwanese',
  '未滿18歲': 'Under 18 yrs old',
  '日期輸入不正確': 'Date input error',
  '流程重做': 'Redo Process',
  '升級.補卡資料不符': 'Upgrade Sim details did not match',
  '非本人': 'Other person',
  '人像照': 'Portrait',
  '補件': 'Send File',
  '其他': 'Other',
  '[201]': 'Check failed; please try again later',
  '[OR1102]': 'Check failed; please try again later',
  '[OR4212]': '',
  '[OR421A]': 'cannot  activate immediately or cannot  activate ',
  '[OR421B]': 'Check failed; please try again later',
  '[OR421C]': 'cannot  activate immediately or cannot  activate ',
  '[OR5101]': 'Check failed; please try again later',
  '[OR5101]': 'Check failed; please try again later',
  '[OR4210]': 'Check failed; please try again later',
  '[OR4211]': '',
  '[OR4213]': '',
  '[OR4214]': '',
}
